import _cmsPageData from "../../dist/cms-page-data.json"

const cmsPageData = _cmsPageData

const { customer_terms, privacy_policy } = cmsPageData

export const hasTerms = () => Object.keys(customer_terms).length > 0
export const hasPrivacyPolicy = () => Object.keys(privacy_policy).length > 0

export const getPageData = (page) => {
  const pageData = cmsPageData[page]

  if (!pageData) {
    return null
  }

  return pageData
}
